import { MerchantStatMissionPage } from "./../merchant-stat-mission/merchant-stat-mission";
import { MerchantHomePage } from "./../merchant-home/merchant-home";
import { MerchantStatShopperPage } from "./../merchant-stat-shopper/merchant-stat-shopper";
import { MerchantStatShopPage } from "./../merchant-stat-shop/merchant-stat-shop";
import { MerchantCashflowPage } from "./../merchant-cashflow/merchant-cashflow";
import { MerchantProfitPage } from "./../merchant-profit/merchant-profit";
import { TranslateService } from "@ngx-translate/core";
import { Http, RequestOptions, Headers } from "@angular/http";
import { ServiceProvider } from "./../../providers/service/service";
import { Storage } from "@ionic/storage";
import { ViewHeaderPage } from "./../view-header/view-header";
import { Component } from "@angular/core";
import { IonicPage, LoadingController, NavController } from "ionic-angular";
import { VideoTutorialModalPage } from "../video-tutorial-modal/video-tutorial-modal";
// import {
//   StreamingMedia,
//   StreamingVideoOptions,
// } from "@ionic-native/streaming-media";

@IonicPage()
@Component({
  selector: "page-merchant-result",
  templateUrl: "merchant-result.html",
})
export class MerchantResultPage {
  stat_unit_sold: any;
  stat_revenue: any;
  stat_shoppee_type: any;
  stat_spending: any;
  round = 1;
  lang = "";
  theme = 1;

  total_unit_sold = {
    total_unit_sold: "",
    plazas: [
      {
        plaza_id: "",
        plaza_name: "",
        unit_sold: "",
      },
    ],
  };

  total_revenue = {
    total_revenue: "",
    plazas: [
      {
        plaza_id: 1,
        plaza_name: "",
        revenue: "",
      },
    ],
  };

  shopper_type = [
    {
      shopper_id: "",
      shopper_name: "",
      shopper_code: "",
      unit_bought: 0,
      bought_price: 0,
    },
  ];

  constructor(
    public navCtrl: NavController,
    private storage: Storage,
    private services: ServiceProvider,
    private http: Http,
    public translateService: TranslateService,
    private loadingCtrl: LoadingController // private streamingMedia: StreamingMedia
  ) {}

  async ionViewDidLoad() {
    const loader = this.loadingCtrl.create({
      content: "Loading...",
    });
    loader.present();

    this.theme = await this.storage.get("theme");

    this.storage.get("roundGame").then((round) => {
      this.storage.get("language").then((lang) => {
        this.lang = lang;
        this.round = round;
      });
    });

    this.storage.get("token").then((token) => {
      var link = this.services.URLMerchantStatUnit;
      var headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + token);
      const requestOptions = new RequestOptions({ headers: headers });

      this.http
        .get(link, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.stat_unit_sold = [];
            this.total_unit_sold = data;
            var total = data.plazas.length;
            for (let i = 0; i < total; i++) {
              this.stat_unit_sold.push([
                data.plazas[i].plaza_name,
                parseInt(data.plazas[i].unit_sold),
              ]);
            }
          },
          (error) => {
            var response = JSON.parse(error._body);
            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );

      var link2 = this.services.URLMerchantRevenue;
      this.http
        .get(link2, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.stat_revenue = [];
            this.total_revenue = data;
            var total = data.plazas.length;
            for (let i = 0; i < total; i++) {
              this.stat_revenue.push([
                data.plazas[i].plaza_name,
                parseInt(data.plazas[i].revenue),
              ]);
            }
          },
          (error) => {
            var response = JSON.parse(error._body);
            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );

      var link3 = this.services.URLMerchantShopperType;
      this.http
        .get(link3, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.stat_shoppee_type = [];
            this.stat_spending = [];
            this.shopper_type = data;
            var total = data.length;
            for (let i = 0; i < total; i++) {
              this.stat_shoppee_type.push([
                data[i].shopper_name,
                parseInt(data[i].unit_bought),
              ]);
              this.stat_spending.push([
                data[i].shopper_name,
                parseInt(data[i].bought_price),
              ]);
            }
            loader.dismiss();
          },
          (error) => {
            var response = JSON.parse(error._body);
            loader.dismiss();
            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );
    });
  }

  profit() {
    this.navCtrl.push(MerchantProfitPage);
  }

  cashflow() {
    this.navCtrl.push(MerchantCashflowPage);
  }

  shop() {
    this.navCtrl.push(MerchantStatShopPage);
  }

  shopper() {
    this.navCtrl.push(MerchantStatShopperPage, {
      stat_unit_sold: this.stat_unit_sold,
      stat_shoppee_type: this.stat_shoppee_type,
      stat_spending: this.stat_spending,
      stat_revenue: this.stat_revenue,
      total_unit_sold: this.total_unit_sold,
      total_revenue: this.total_revenue,
      shopper_type: this.shopper_type,
    });
  }

  backPage() {
    this.navCtrl.setRoot(MerchantHomePage);
  }
  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }

  homePage() {
    this.navCtrl.setRoot(MerchantHomePage);
  }

  mission() {
    this.navCtrl.push(MerchantStatMissionPage);
  }

  showVideo() {
    // let options: StreamingVideoOptions = {
    //   successCallback: () => {
    //     console.log("Video played");
    //   },
    //   errorCallback: (e) => {
    //     console.log("Error streaming");
    //   },
    //   orientation: "landscape",
    //   shouldAutoClose: true,
    //   controls: true,
    // };

    if (this.lang == "en-Us") {
      this.storage.get("video").then((video) => {
        this.navCtrl.push(VideoTutorialModalPage, {
          id: 14,
          vdo: video[14].video_url,
        });
        // this.streamingMedia.playVideo(video[14].video_url, options);
      });
    } else {
      this.storage.get("video").then((video) => {
        this.navCtrl.push(VideoTutorialModalPage, {
          id: 15,
          vdo: video[15].video_url,
        });
        // this.streamingMedia.playVideo(video[15].video_url, options);
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/merchant-result/merchant-result.ts